const isNationSafeDriversEmail = (email) =>
  email?.toLowerCase().includes('@nationsafedrivers.com');

export { isNationSafeDriversEmail };
